import { Flex, Spin } from 'antd';
import React from 'react';
import SearchInput from '~/components/shared/SearchInput/SearchInput';
import { useConversationSidebar } from '~/hooks/useConversationSidebar';

import TabsGroup from '../../OrdersCatalogue/TabsGroup/TabsGroup';
import CreateConversationModal from '../ConversationSearch/CreateConversationModal/CreateConversationModal';
import ConversationListFlat from './ConversationListFlat';
import ConversationListGrouped from './ConversationListGrouped';

function ConversationsSidebar({ params, changeParams, selectedConversation, setSelectedConversation, activeMerchantId, navigateToConversationStatus }) {
  const { isLoading, data, isOpenTab, tabItems, handleSelectConversation, searchByOrderNumber, searchNotFound, isSearching } = useConversationSidebar({
    activeMerchantId,
    params,
    changeParams,
    setSelectedConversation,
    navigateToConversationStatus,
  });

  return (
    <Flex vertical className='h-full'>
      <div className='shrink-0 px-s'>
        <TabsGroup items={tabItems} />
      </div>
      <Flex vertical gap={8} className='overflow-y-auto flex-1 pt-m'>
        <Flex vertical gap={8} className='px-m'>
          <CreateConversationModal setSelectedConversation={setSelectedConversation} customText='Démarrer une conversation' />
          <SearchInput placeholder='N° de commande' search={searchByOrderNumber} />
          {searchNotFound && <p className='body2 text-grey-medium px-xs'>Aucune conversation trouvée</p>}
          {(isLoading || isSearching) && (
            <Flex justify='center' align='center' className='py-2xl'>
              <Spin size='large' />
            </Flex>
          )}
        </Flex>
        {data && data.length > 0 && (
          <>
            {isOpenTab ? (
              <ConversationListGrouped conversations={data} selectedConversation={selectedConversation} onSelectConversation={handleSelectConversation} />
            ) : (
              <ConversationListFlat conversations={data} selectedConversation={selectedConversation} onSelectConversation={handleSelectConversation} />
            )}
          </>
        )}
      </Flex>
    </Flex>
  );
}

export default ConversationsSidebar;
